module.exports = __webpack_public_path__ + "img/category-8.dc8d186f.svg";